// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainPage_MainPage__DBufn .MainPage_RightSide__sR5x9 {
  width: 100%;
  padding: 20px;
}
.MainPage_MainPage__DBufn .MainPage_RightSide__sR5x9 .MainPage_Title__XHsBm {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/MainPage/MainPage.module.scss"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,aAAA;AAAR;AAEQ;EACI,kBAAA;AAAZ","sourcesContent":[".MainPage {\n    .RightSide {\n        width: 100%;\n        padding: 20px;\n\n        .Title {\n            text-align: center;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MainPage": `MainPage_MainPage__DBufn`,
	"RightSide": `MainPage_RightSide__sR5x9`,
	"Title": `MainPage_Title__XHsBm`
};
export default ___CSS_LOADER_EXPORT___;
